<template>
  <el-dialog @close="dialogClose"
             class="edit-rule-dialog"
             :title="(dialogStatus==='create'?'新增':'修改')+'规则段'"
             :visible.sync="visible">
    <el-form :model="editRuleForm"
             :rules="formRules"
             ref="editRuleForm"
             label-width="80px">
      <el-row>
        <el-col :span="20">
          <el-form-item label="规则名称"
                        prop="rule_name">
            <el-input placeholder="请输入规则名称"
                      v-model="editRuleForm.rule_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="数据来源"
                        prop="sources_data">
            <el-select placeholder="请选择数据来源"
                       class="col-12"
                       v-model="editRuleForm.sources_data">
              <el-option v-for="(item) in dataSourceCode"
                         :key="item.code_id"
                         :value="item.value"
                         :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="参数值"
                        prop="para_value">
            <el-input placeholder="请输入参数值"
                      v-if="editRuleForm.sources_data!=='4'"
                      v-model="editRuleForm.para_value"></el-input>
            <el-input placeholder="请选择流水段"
                      v-if="editRuleForm.sources_data==='4'"
                      disabled
                      v-model="editRuleForm.para_name"></el-input>
            <el-button type="primary"
                       class="choose-flow-btn"
                       v-if="editRuleForm.sources_data==='4'"
                       @click="showFlowDialog">选择</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开始位"
                        prop="start_num">
            <el-input placeholder="请输入开始位"
                      v-model="editRuleForm.start_num">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="4"
                :span="8">
          <el-form-item label="截止位"
                        prop="end_num">
            <el-input placeholder="请输入截止位"
                      v-model="editRuleForm.end_num">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="数据填充"
                        prop="fill_style">
            <el-select v-model="editRuleForm.fill_style"
                       placeholder="请选择填充方式">
              <el-option v-for="(item) in fillStyleCode"
                         :key="item.code_id"
                         :value="item.value"
                         :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item prop="fill_style_value">
            <el-input v-model="editRuleForm.fill_style_value"
                      placeholder="请输入填充值">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="dialogClose">取消</el-button>
      <el-button type="primary"
                 @click="editRuleSection">确定</el-button>
    </div>

    <el-dialog :visible.sync="chooseFlowDialogVisible"
               width="60%"
               append-to-body
               title="选择流水段">
      <encodeRule :isComponent="true"
                  :companyId="'92'"
                  ref="encodeRules"></encodeRule>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="chooseFlowDialogVisible=false" id="back-style">取 消</el-button>
        <el-button type="primary"
                   @click="chooseFlowSection">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { standardCodeApi } from '@/services/StandardCode'
import { EncodeRuleApi } from '@/services/EncodeRule'

export default {
  data () {
    return {
      visible: false,
      // 表单对象
      editRuleForm: {
        rule_name: '',
        sources_data: '',
        para_value: '',
        start_num: '',
        end_num: '',
        rule_code_resolve_id: '',
        fill_style: '',
        fill_style_value: '',
        company_id: ''
      },
      tempForm: {
        rule_name: '',
        sources_data: '',
        para_value: '',
        start_num: '',
        end_num: '',
        rule_code_resolve_id: '',
        fill_style: '',
        fill_style_code: '',
        fill_style_value: '',
        company_id: ''
      },
      // 表单验证规则
      formRules: {
        rule_name: [
          { required: true, message: '请输入规则名称', trigger: 'blur' }
        ],
        sources_data: [
          { required: true, message: '请选择数据来源', trigger: 'blur' }
        ],
        para_value: [
          { required: true, message: '请输入参数值', trigger: 'blur' }
        ],
        start_num: [
          { required: true, message: '请输入开始位', trigger: 'blur' }
        ],
        end_num: [
          { required: true, message: '请输入截止位', trigger: 'blur' }
        ],
        fill_style: [
          { required: true, message: '请选择数据填充方式', trigger: 'blur' }
        ],
        fill_style_value: [
          { required: true, message: '请输入数据填充值', trigger: 'blur' }
        ]
      },
      // 数据来源标准码
      dataSourceCode: [],
      // 填充方式标准码
      fillStyleCode: [],
      // 选择流水段弹框是否可见
      chooseFlowDialogVisible: false
    }
  },
  name: 'editRuleSectionDialog',
  props: {
    dialogVisible: {
      type: Boolean
    },
    dialogForm: {
      type: Object
    },
    dialogStatus: {
      type: String
    },
    callback: {
      type: Function
    }
  },
  watch: {
    dialogVisible (newval) {
      this.visible = newval
    },
    dialogForm: {
      handler (newval) {
        let tempForm = JSON.parse(JSON.stringify(this.tempForm))
        this.editRuleForm = Object.assign(tempForm, JSON.parse(JSON.stringify(newval)))
        // 如果编辑的是流水段，需要将流水段名称和流水段id代入
        if (this.editRuleForm.para_value && this.editRuleForm.sources_data === '4') {
          this.editRuleForm.para_name = this.editRuleForm.para_value
          this.editRuleForm.para_value = this.editRuleForm.sources_para_value
        }
        console.log(this.editRuleForm, newval, tempForm, '1123')
      },
      deep: true
    }
  },
  components: {

  },
  methods: {
    dialogClose () {
      this.$refs.editRuleForm.resetFields()
      this.$emit('update:dialogVisible', false)
    },
    // 获取数据来源标准码
    getDataSourceCode () {
      standardCodeApi.getStandardCodeData({
        params: {
          code_type: 'dataSources',
          is_page: 0
        }
      }).then(res => {
        console.log(res, 'get datasource cpde')
        if (res.code === 0) {
          this.dataSourceCode = res.data.list
          window.localStorage.setItem('dataSourceCode', JSON.stringify(this.dataSourceCode))
        }
      }, err => {
        console.log(err)
      })
    },
    // 获取填充方式标准码
    getFillStyleCode () {
      standardCodeApi.getStandardCodeData({
        params: {
          code_type: 'fillStyle',
          is_page: 0
        }
      }).then(res => {
        console.log(res, 'get fillstyle code')
        if (res.code === 0) {
          this.fillStyleCode = res.data.list
          window.localStorage.setItem('fillStyleCode', JSON.stringify(this.fillStyleCode))
        }
      }, err => {
        console.log(err)
      })
    },
    // 根据状态调用新增或编辑接口
    editRuleSection () {
      this.$refs.editRuleForm.validate((valid) => {
        if (valid) {
          if (this.dialogStatus === 'create') {
            this.createRuleSection()
          } else {
            this.updateRuleSection()
          }
        }
      })
    },
    // 新增规则段接口
    createRuleSection () {
      EncodeRuleApi.createRuleSection({
        data: this.editRuleForm
      }).then(res => {
        console.log(res, 'create rule section')
        if (res.code === 0) {
          this.$message.success('新增规则成功')
          this.dialogClose()
          this.$emit('callback', res.data)
        }
      }, err => {
        console.log(err)
      })
    },
    // 修改规则接口
    updateRuleSection () {
      EncodeRuleApi.updateRuleSection({
        data: this.editRuleForm
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('修改规则成功')
          this.dialogClose()
          this.$emit('callback', res.data)
        }
      })
    },
    // 显示选择流水段弹框
    showFlowDialog () {
      this.chooseFlowDialogVisible = true
      this.$nextTick(() => {
        this.$refs.encodeRules.getEncodeTreeParam.company_id = this.editRuleForm.company_id
        this.$refs.encodeRules.getEncodeTreeData()
      })
    },
    // 选择流水段
    chooseFlowSection () {
      console.log(this.$refs.encodeRules)
      let node = this.$refs.encodeRules.curNode
      if (node.resolve_type !== '2') {
        this.$message.warning('请选择流水段')
      } else {
        this.editRuleForm.para_value = node.rule_code_resolve_id
        this.editRuleForm.para_name = node.name
        this.chooseFlowDialogVisible = false
      }
    }
  },
  async created () {
    let dataSourceLocal = window.localStorage.getItem('dataSourceCode')
    let fillStyleLocal = window.localStorage.getItem('fillStyleCode')
    if (dataSourceLocal) {
      this.dataSourceCode = JSON.parse(dataSourceLocal)
    } else {
      await this.getDataSourceCode()
    }
    if (fillStyleLocal) {
      this.fillStyleCode = JSON.parse(fillStyleLocal)
    } else {
      await this.getFillStyleCode()
    }
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
.edit-rule-dialog {
  .choose-flow-btn {
    position: absolute;
    right: -90px;
  }
  .back-style{
    margin-right:12px
  }
  .dialog-footer{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SettingManage/components/EditRuleSectionDialog.vue